import { showApiErrors } from '@/utils';
import { createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { approveSuggestedFaq, rejectSuggestedFaq, getSuggestedFaqById } from './actionCreators';
import { SuggestedFaqDetailsState, SLICE_NAME, initialState } from './models';

export const suggestedFaqDetailsSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSuggestedFaqById.pending, (state: SuggestedFaqDetailsState, action) => {
        state.isLoading = true;
        state.error = null;
        if (state.item?.reviewId !== action.meta.arg.reviewId) {
          state.item = null;
        }
      })
      .addCase(getSuggestedFaqById.fulfilled, (state: SuggestedFaqDetailsState, action) => {
        state.isLoading = false;
        state.item = action.payload;
      })
      .addCase(approveSuggestedFaq.fulfilled, (state: SuggestedFaqDetailsState, action) => {
        state.isLoading = false;
        if (state.item) {
          state.item = {
            ...state.item,
            ...action.payload.suggestion,
          };
        }
      })
      .addCase(rejectSuggestedFaq.fulfilled, (state: SuggestedFaqDetailsState, action) => {
        state.isLoading = false;
        if (state.item) {
          state.item = {
            ...state.item,
            ...action.payload,
          };
        }
      })
      .addMatcher(isPending(approveSuggestedFaq, rejectSuggestedFaq), (state: SuggestedFaqDetailsState) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(
        isRejected(getSuggestedFaqById, approveSuggestedFaq, rejectSuggestedFaq),
        (state: SuggestedFaqDetailsState, action) => {
          const { error } = action;

          state.isLoading = false;
          state.error = error;
          showApiErrors(error);
        },
      );
  },
});
